export default __webpack_public_path__ + "static/media/eth-homepage.0af94d57.gif";